/**
 * 获得两个变量中存在的变量
 * @param var1
 * @param var2
 * @returns {*}
 */
export function getExist (var1, var2) {
  if (var1 === undefined) {
    return var2
  }
  return var1
}

export function arraySwap (array, oldIndex, newIndex) {
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0])
  return array
}

export function copyJson (data) {
  return JSON.parse(JSON.stringify(data))
}

export function dateNumber () {
  return (new Date()).toJSON()
  // 2018-07-31T07:48:48.653Z
    .substr(0, 19)
    // 2018-07-31T07:48:48
    .replace(/[^0-9]/ig, '')
  // 20180731074848
}



// WEBPACK FOOTER //
// ./src/views/question-editor/utils/function.js